import React, { Component } from "react";
import { Typeahead, AsyncTypeahead } from "react-bootstrap-typeahead"; // ES2015
import "react-bootstrap-typeahead/css/Typeahead.css";
import "./admin.css";

export default class AdminNovaPoshta extends Component {
    constructor(props) {
        super(props);
        this.state = { isLoading: false, options: [], city: null };
    }

    onCopyClick = (e) => {
        navigator.clipboard
            .writeText(this.state.city.uk)
            .then(() => {
                console.log("Writed to clipboard");
            })
            .catch((err) => {
                console.error("Failed to write to clipboard", err);
                alert(err);
            });
        e.preventDefault();
    };

    onTypeheadChange = (e) => {
        var value = e ? e[0] : null;
        this.setState({ city: value });
    };

    render() {
        function range(start, end) {
            return Array.from({ length: end - start + 1 }, (_, i) => i);
        }

        //const options = range(0, 1000).map((o) => `Option ${o.toString()}`);

        return (
            <div className="container">
                <div
                    className="d-block d-md-flex justify-content-center align-items-center"
                    style={{ height: "100vh" }}>
                    <div className="form-group w-100 g-mt-10">
                        <h5>Поиск по названию города</h5>
                        <AsyncTypeahead
                            id="autocomplete"
                            isLoading={this.state.isLoading}
                            clearButton={true}
                            size={"large"}
                            highlightOnlyResult={true}
                            placeholder="Введите название на украинском"
                            labelKey={(option) => `${option?.uk}`}
                            onSearch={(query) => {
                                this.setState({ isLoading: true });
                                fetch(`/api/novaposhta/cities/${query}`)
                                    .then((resp) => resp.json())
                                    .then((json) =>
                                        this.setState({
                                            isLoading: false,
                                            options: json,
                                        })
                                    );
                            }}
                            options={this.state.options}
                            onChange={this.onTypeheadChange}/>
                        <p className="text-muted g-my-5">{(this.state.city?.ru) ? "ru: " + (this.state.city?.ru) : "\u00A0"
                        }</p>
                        <button
                            className="btn u-btn-primary g-font-size-13 g-py-10 g-mt-0"
                            onClick={this.onCopyClick}
                            disabled={!this.state.city}>
                            Скопировать ua
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}